$(function() {
  $('div.alert')
    .not('.alert-important')
    .delay(3000)
    .fadeOut(350)

  // public navigation
  $('.site-navigation .active').removeClass('active')
  $('.site-mobile-menu-body .active').removeClass('active')

  $('a[href="' + window.location.href + '"]')
    .parent()
    .addClass('active')

  if (window.location.href === window.location.origin + '/') {
    $('a[href="' + window.location.origin + '"]')
      .parent()
      .addClass('active')
  }

  $('.disable-submit-btn').submit(function () {
    $(this).find('button[type="submit"]').attr('disabled', true);
  })
})
